import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_OL_ESPLETATO_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, StoreConfig, EntityStore } from "@datorama/akita";

export interface IIDolEspletatoKoState extends EntityState<IID_OL_ESPLETATO_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_ESPLETATO_KO })
export class IIDolEspletatoKoStore extends EntityStore<IIDolEspletatoKoState> {
  constructor() {
    super([]);
  }
}
